import { useContext, useState, useEffect } from 'react';
import ListHeader from '../../SectionHeader';
import TablePagination from '../../TablePaginationComponent';
import GlobalContext from '../../../contexts/index';
import useFetchData from '../../../hooks/useFetchData';
import useSort from '../../../hooks/useSort';
import { ReactComponent as SortIcon } from '../../../assets/images/sort.svg';
import Filter from '../../Filter';
import { useNavigate, useSearchParams } from 'react-router-dom';
import globalTranslating from '../../../translate.json';
import BloodParamsTranslating from '../translate.json';
import SnackBar from 'components/SnackBar';

const BloodTestForm = () => {
  const translating = { ...globalTranslating, ...BloodParamsTranslating };

  const navigate = useNavigate();
  const { setLink } = useContext(GlobalContext);
  const [filteredBloodParams, setFilteredBloodParams] = useState([]);
  const { data: bloodParamsData, loading } = useFetchData('blood-param');
  const [searchParams] = useSearchParams();
  const [showSnackbar, setShowSnakbar] = useState(false);

  useEffect(() => {
    const isAdded = searchParams.get('added');
    if (isAdded) {
      setShowSnakbar(true);
      searchParams.delete('added');
      window.history.replaceState(
        null,
        '',
        `${window.location.origin}${window.location.pathname}`
      );
    }
  }, []);

  useEffect(() => {
    if (bloodParamsData?.length) setFilteredBloodParams(bloodParamsData);
  }, [bloodParamsData]);

  const onFilter = (filteredData) => {
    setFilteredBloodParams(filteredData);
  };

  const onResetFilters = () => {
    setFilteredBloodParams(bloodParamsData);
  };

  const { showFilters, toggle } = useSort();

  const tableHeaders = [
    'id',
    translating.name,
    translating.genderLab,
    translating.minB1,
    translating.maxB1,
    translating.minB2,
    translating.maxB2,
    translating.minB3,
    translating.maxB3
  ];

  const columns = [
    { value: 'id' },
    { value: 'name', bold: true },
    { value: 'genderLab' },
    { value: 'minB1Value' },
    { value: 'maxB1Value' },
    { value: 'minB2Value' },
    { value: 'maxB2Value' },
    { value: 'minB3Value' },
    { value: 'maxB3Value' }
  ];

  const sortFields = [
    {
      type: 'search',
      label: translating.search,
      placeholder: translating.type3Dots,
      name: 'search',
      fields: ['name']
    }
  ];

  const actionsUsersList = [
    {
      icon: SortIcon,
      bottom: true,
      txt: translating.edit,
      handleClickAction: () => {
        showFilters && setFilteredBloodParams(bloodParamsData);
        toggle(!showFilters);
      }
    }
  ];

  return (
    <div className="blood-params-list">
      <ListHeader
        title={translating.BloodParamsListTitle}
        newItem={{ handleClick: () => setLink('d2') }}
        actions={actionsUsersList}
      ></ListHeader>
      {showFilters && (
        <Filter
          fields={sortFields}
          data={bloodParamsData}
          handleFilter={onFilter}
          handleReset={onResetFilters}
        ></Filter>
      )}
      <div className="blood-params-wrapper-table">
        {loading && <div>Loading</div>}
        {bloodParamsData && (
          <TablePagination
            headers={tableHeaders}
            columns={columns}
            rows={filteredBloodParams}
            pagination={true}
            handleRowClick={(id) => {
              navigate(`/labs/blood/${id}`);
            }}
          ></TablePagination>
        )}
      </div>
      {showSnackbar && (
        <SnackBar
          msg={'מדד נוסף'}
          handleClose={() => setShowSnakbar(false)}
        ></SnackBar>
      )}
    </div>
  );
};

export default BloodTestForm;
